import { GwrControlClient, type TokenStore } from "@gwrctl/api-client";

const ACCESS_KEY = "gwrctl.access";
const REFRESH_KEY = "gwrctl.refresh";

/**
 * Token'lar localStorage'da. Bu bir tek kullanıcılı yönetim paneli; refresh token'ı
 * httpOnly cookie'ye taşımak XSS'e karşı daha iyi olurdu ama konsol ayrı bir origin'de
 * (ops.gwrlabs.com → ctl.gwrlabs.com) çalıştığı için cookie akışı ek CSRF yüzeyi
 * getirirdi. Taviz bilinçli; oturumlar cihaz başına iptal edilebilir.
 */
const tokenStore: TokenStore = {
  getAccess: () => localStorage.getItem(ACCESS_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_KEY),
  set: ({ accessToken, refreshToken }) => {
    localStorage.setItem(ACCESS_KEY, accessToken);
    if (refreshToken) localStorage.setItem(REFRESH_KEY, refreshToken);
  },
  clear: () => {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  },
};

const baseUrl = import.meta.env.VITE_API_URL ?? "/api";

export const client = new GwrControlClient(baseUrl, tokenStore, () => {
  // Oturum düştü → giriş ekranına. Router dışından çağrıldığı için tam yenileme.
  if (location.pathname !== "/login") location.href = "/login";
});

export const hasSession = (): boolean => tokenStore.getAccess() !== null;
export const clearSession = (): void => tokenStore.clear();
